// extracted by mini-css-extract-plugin
export default {"Content":"Bgl9KVniVQmUzgMcE17F","Button":"eWidAv9t5rtdJzuDE5kH"};